module.exports = __webpack_public_path__ + "static/review-1-9fc5622e1d084ad940401d8dbcc8295f.jpg";